/**
* @Description 文件功能说明：角色组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'tree-item-box': true, 'mini-box': !showBoxFlag}">

		<div class="box-bar-item" @click="toggleBox" title="展开/收起 角色授权">
			<i v-if="showBoxFlag" class="iconfont el-icon-my_left2-copy"></i>
			<i v-else class="iconfont el-icon-my_right2"></i>
		</div>

        <div class="tree-group-title">
            <span class="tree-group-name">角色授权</span>
            <el-button v-if="false" class="tree-group-btn" icon="el-icon-circle-plus-outline" size="mini" @click="addRole" >新增角色</el-button>
        </div>

        <div class="tree-group-item">
            <el-tree
                :props="defaultProps"
                :data="roles"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleTreeNode"
            >
                <template v-slot="{node, data}">
                    <span class="custom-tree-node"
                          @mouseenter="mouseenter(data)"
                          @mouseleave="mouseleave(data)"
                    >
                    <span>{{data.label}}</span>
                    <span v-if="false" class="tree-item-button">
                        <el-button
                            type="text"
                            size="mini"
                            icon="el-icon-edit"
                            v-show="data.show"
                            @click="() => {edit(data)}"
                            v-if="data.name != '超级管理员角色'"
                        >
                        </el-button>
                    </span>
                </span>
                </template>
            </el-tree>
        </div>

        <!--添加或编辑角色弹窗-->
        <RoleDialog ref="roleDialog"/>

    </div>

</template>

/* JS */
<script>
    import RoleDialog from './RoleDialog.vue'
    import ApiOam from '@/request/api-oam'
    import store from '@/store/index'

    export default {

        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/4
         */
        props: {
            // 角色集合
            roles: Array,
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/6/5
             */
			showBoxFlag: {
				type: Boolean,
				default: function (){
					return true
				}
			},
        },

        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/4
         */
        components: {
            // 角色弹窗
            RoleDialog
        },

        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/4
         */
        data() {
            return {

                /**
                 * @Des 树属性默认定义
                 * @Auth
                 * @Date 2021/6/4
                 */
                defaultProps: {
                    label: 'name',
                    children: 'children'
                },
                // 角色名
                roleName: '',
                // 删除锁
                deleteLock: false,
            }
        },

        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/4
         */
        methods: {
			/**
             * @Des mini max box
             * @Auth
             * @Date 2021/6/5
             */
			toggleBox() {
				this.$emit('toggleBox', !this.showBoxFlag);
			},

            /**
             * @Des 添加角色
             * @Auth
             * @Date 2021/6/4
             */
            addRole(){
                this.$refs.roleDialog.openRoleDialog(false)
            },

            /**
             * @Des 编辑角色
             * @Auth
             * @Date 2021/6/4
             */
            edit(data){
                this.$refs.roleDialog.openRoleDialog(true, data)
            },

            /**
             * @Des 删除角色
             * @Auth
             * @Date 2021/6/4
             */
            remove(data){
                this.deleteLock = true;
                if(data.children && data.children.length > 0){
                    this.$message({
                        message: '角色下有子角色，不能删除',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.deleteLock = false;
                    return false;
                }
                this.$confirm('确认要删除【' + data.name + '】角色吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$request.postJsonRequest(ApiOam.Delete_Role_Uri,{
                        roleId: data.id
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '角色【' + data.name + '】删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.$parent.searchRole()
                            this.$parent.setSelectVal()
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.deleteLock = false;
                    }).catch(error => {
                    	this.deleteLock = false;
                        console.error('删除角色异常', ApiOam.Delete_Role_Uri, error);
                    })
                }).catch(() => {
                    this.deleteLock = false;
                })
            },

            /**
             * @Des 处理树节点
             * @Auth
             * @Date 2021/6/4
             */
            handleTreeNode(data){
                if(this.$refs.roleDialog.dialogTreeItem.dialogFormVisible){
                    return false;
                }
                if(this.deleteLock){
                    return false;
                }
                this.$emit('setSelectVal', data);
            },
            /**
             * @Des 鼠标进入事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseenter(data){
                this.$set(data, 'show', true);
            },
            /**
             * @Des 鼠标离开事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseleave(data){
                this.$set(data, 'show', false)
            },
        },

        /**
         * @Des 初始化加载
         * @Auth
         * @Date 2021/6/4
         */
        mounted() {
            this.roleName = JSON.parse(store.state.userRole)[0].name;
        }

    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components_pages/Account/RoleTree.vue